import { Dropdown } from 'react-bootstrap'
import styled from 'styled-components'

export const DropdownToggle = styled(Dropdown.Toggle)`
  padding: 6px 12px;
`
